
        <!-- Since issue 53  -->
        <div class="card-header" id="extractionInstallHeader">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                data-target="#extractionInstallCollapse" aria-expanded="true" aria-controls="extractionInstallCollapse">
                Rechercher une liste de contrats
            </button>
        </div>

        <div id="extractionInstallCollapse" class="panel-collapse collapse" aria-labelledby="extractionInstallHeader"
            data-parent="#accordionExtraction">

            <div class="card-body row">
                <form [formGroup]="searchInstallForm" (ngSubmit)="onSubmitInstall()" class="wrapper shadowed">
                    <h4>Rechercher une liste de contrats</h4>
                    <br>
                    <div class="paragraphe">
                        <p class="dateContrat">Type de contrat</p>
                        <mat-form-field>
                            <mat-select formControlName="contractTypeInstall" placeholder="Type de contrat">
                                <mat-option>Tous</mat-option>
                                <mat-option *ngFor="let type of typesContrat" [value]="type.ID_CONTRAT_SAV">
                                    {{type.NOM_CONTRAT}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="paragraphe">
                        <p class="dateContrat">Début du contrat</p>
                        <mat-form-field>
                            <mat-select formControlName="operatorDebut" placeholder="Début">
                                <mat-option value='avant'>Avant le</mat-option>
                                <mat-option value='apres'>Après le</mat-option>
                                <mat-option value='est'>le</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput [matDatepicker]="pickerstartDateContract" placeholder="Date de début de contrat"
                                formControlName="startDateContract">
                            <mat-datepicker-toggle matSuffix [for]="pickerstartDateContract"></mat-datepicker-toggle>
                            <mat-datepicker #pickerstartDateContract startView="year"></mat-datepicker>
                        </mat-form-field>

                    </div>

                    <div class="paragraphe">
                        <p class="dateContrat">Fin du contrat</p>
                        <mat-form-field>
                            <mat-select formControlName="operatorFin" placeholder="Fin" [ngModel]="selectedValue" (ngModelChange)="onChange($event)">
                                <mat-option value='avant'>Avant le</mat-option>
                                <mat-option value='apres'>Après le</mat-option>
                                <mat-option value='est'>Est le</mat-option>
                                <mat-option value='entre'>Entre</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <ng-container *ngIf="selectedValue != 'entre'">
                            <mat-form-field>
                                <input matInput [matDatepicker]="pickerendDateContract" placeholder="Date de fin de contrat"
                                    formControlName="endDateContract1">
                                <mat-datepicker-toggle matSuffix [for]="pickerendDateContract"></mat-datepicker-toggle>
                                <mat-datepicker #pickerendDateContract startView="year"></mat-datepicker>
                            </mat-form-field>
                        </ng-container>
                    </div>

                    <div>
                    <ng-container *ngIf="selectedValue == 'entre'">
                        <mat-form-field appearance="fill">
                            <mat-label>Date de fin de contrat</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                              <input matStartDate formControlName="endDateContract1" placeholder="Start date">
                              <input matEndDate formControlName="endDateContract2" placeholder="End date">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                    </ng-container>
                    </div>
                    
                    <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button>

                </form>
                <br><br>

                <app-gmao-spinner *ngIf="isLoading"></app-gmao-spinner>


                <ng-container *ngIf="installContracts">
                    <div class="wrapper shadowed">

                        <br />

                        <h4>Résultats</h4>

                        <app-export-button [data]="installContracts"></app-export-button>

                        <br />

                        <ng-container *ngIf="installContracts">
                            <p>Total pour la période sélectionée : <span
                                    class="count-total">{{installContracts.length}}</span>
                            </p>
                        </ng-container>

                        <mat-table [dataSource]="installContracts">
                            <ng-container matColumnDef="numSerie">
                                <mat-header-cell *matHeaderCellDef> Numéro de série </mat-header-cell>
                                <mat-cell *matCellDef="let install"> {{install.NUMERO_SERIE}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="nom">
                                <mat-header-cell *matHeaderCellDef> Nom de l'installation </mat-header-cell>
                                <mat-cell *matCellDef="let install"> {{install.NOM_INSTALLATION}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="contrat">
                                <mat-header-cell *matHeaderCellDef> Contrat </mat-header-cell>
                                <mat-cell *matCellDef="let install"> {{install.NOM_CONTRAT}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="dateDebut">
                                <mat-header-cell *matHeaderCellDef> Début du contrat</mat-header-cell>
                                <mat-cell *matCellDef="let install"> {{getNiceDate(install.DATE_DEBUT)}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="dateFin">
                                <mat-header-cell *matHeaderCellDef> Fin du contrat</mat-header-cell>
                                <mat-cell *matCellDef="let install"> {{getNiceDate(install.DATE_FIN)}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="mail">
                                <mat-header-cell *matHeaderCellDef>Courriel</mat-header-cell>
                                <mat-cell *matCellDef="let install"> {{install.ADRESSE_EMAIL}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="cp">
                                <mat-header-cell *matHeaderCellDef>Code postal</mat-header-cell>
                                <mat-cell *matCellDef="let install"> {{install.CODE_POSTAL}} </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumnInstall"></mat-header-row>
                            <mat-row
                                *matRowDef="let row; columns: ['numSerie', 'nom', 'contrat', 'dateDebut', 'dateFin', 'mail', 'cp' ] ;">
                            </mat-row>
                        </mat-table>

                    </div>
                </ng-container>
                <br />
            </div>
        </div>
